import { render, staticRenderFns } from "./CadastroComunicacaoNps.vue?vue&type=template&id=8730a9d4&"
import script from "./CadastroComunicacaoNps.vue?vue&type=script&lang=js&"
export * from "./CadastroComunicacaoNps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports